<template>
<!--    <div id="panel-eco">-->
<!--        <a href="http://www.agrohana.cz/"-->
<!--           class="d-inline-block mod">-->
<!--            <img src="/images/agrohana.png"></a>-->
<!--        <a href="http://www.ecopark.cz/"-->
<!--           class="d-inline-block">-->
<!--            <img src="/images/eco_finance_thumb.png"></a>-->
<!--        &lt;!&ndash;        <a href="http://www.cerstveutrzeno.cz"&ndash;&gt;-->
<!--        &lt;!&ndash;           class="d-inline<style scoped-->
<!--               lang="scss">-->
<!--            @import '~bootstrap/scss/bootstrap';-->

<!--            //Panel for Eco Finance Group-->

<!--        </style>-block">&ndash;&gt;-->
<!--        &lt;!&ndash;            <img src="/img/cerstveutzeno.png" style="padding-left: 15px; width: 60px"></a>&ndash;&gt;-->

<!--        <div class="d-inline-block ml-4 caption mr-auto float-right">Jsme součástí holdingu <a href="http://www.ecopark.cz/">Eco Finance-->
<!--            Group s.r.o.</a> a členem odbytového družstva <a href="https://cerstveutrzeno.cz/">Čerstvě-->
<!--            utrženo.</a>-->
<!--        </div>-->

<!--    </div>-->
    <div id="panel-eco">
        <a href="http://www.agrohana.cz/"
           class="d-inline-block mod">
            <img src="/images/agrohana.png"></a>
        <a href="http://www.ecopark.cz/"
           class="d-inline-block ms-1">
            <img src="/images/eco_finance_thumb.png"></a>
        <!--        <a href="http://www.cerstveutrzeno.cz"-->
        <!--           class="d-inline-block">-->
        <!--            <img src="/img/cerstveutzeno.png" style="padding-left: 15px; width: 60px"></a>-->



    </div>

</template>

<script>
export default {
    name: "PanelEcoPark"
}
</script>
